<template>
  <b-col>
    <b-row>
      <b-col><h2>Карточка юридического лица</h2></b-col>
      <b-col class="col-2"
        ><b-button
          variant="outline-primary"
          class="d-flex justify-content-right mb-3 float-right"
          v-b-modal.modal-1
          >Редактировать</b-button
        ></b-col
      >
    </b-row>

    <b-row class="mb-2">
      <b-col class="col-5"
        ><span class="mr-sm-2">Название организации</span></b-col
      >
      <b-col
        ><span>{{ orgname }}</span></b-col
      >
    </b-row>
    <b-row class="mb-2">
      <b-col class="col-5"><span class="mr-sm-2">ИНН</span></b-col>
      <b-col
        ><span>{{ inn }}</span></b-col
      >
    </b-row>
    <b-row class="mb-2">
      <b-col class="col-5"><span class="mr-sm-2">КПП</span></b-col>
      <b-col
        ><span>{{ kpp }}</span></b-col
      >
    </b-row>
    <b-row class="mb-2">
      <b-col class="col-5"
        ><span class="mr-sm-2">Юридический адрес</span></b-col
      >
      <b-col
        ><span>{{ legal_address }}</span></b-col
      >
    </b-row>
    <b-row class="mb-2">
      <b-col class="col-5"
        ><span class="mr-sm-2">Email для выставления счетов</span></b-col
      >
      <b-col
        ><span>{{ billing_email }}</span></b-col
      >
    </b-row>

    <b-modal
      id="modal-1"
      hide-footer
      header-class="align-items-center pt-reduced pb-reduced"
    >
      <template #modal-header="{ close }">
        <h5 class="mb-0">Изменить персональную информацию</h5>

        <b-button
          variant="text"
          @click="close()"
          class="btn-close bg-transparent p-0 d-flex align-items-center justify-content-center"
          style="min-height: 24px"
        >
          <i
            class="ri-close-line hp-text-color-dark-0 lh-1"
            style="font-size: 24px"
          ></i>
        </b-button>
      </template>
      <ValidationObserver v-slot="{ valid }">
        <b-form class="col-12">
          <b-form-group
            id="orgname-profile-group"
            label="Название организации"
            label-for="orgname-profile"
          >
            <b-form-input
              id="orgname-profile"
              v-model="new_orgname"
              type="text"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="inn-profile-group"
            label="ИНН"
            label-for="inn-profile"
          >
            <b-form-input
              id="inn-profile"
              v-model="new_inn"
              type="text"
              readonly
            ></b-form-input
          ></b-form-group>
          <b-form-group
            id="kpp-profile-group"
            label="КПП"
            label-for="kpp-profile"
          >
            <b-form-input
              id="kpp-profile"
              v-model="new_kpp"
              type="text"
            ></b-form-input
          ></b-form-group>

          <b-form-group
            id="legal-address-profile-group"
            label="Юридический адрес"
            label-for="legal-address-profile"
            ><b-form-input
              id="legal-address-profile"
              v-model="new_legal_address"
              type="text"
            ></b-form-input
          ></b-form-group>

          <b-form-group
            id="billing-email-profile-group"
            label="Юридический адрес"
            label-for="billing-email-profile"
            ><b-form-input
              id="billing-email-profile"
              v-model="new_billing_email"
              type="email"
            ></b-form-input
          ></b-form-group>
          <b-form-row class="mt-5">
            <b-col
              ><b-button
                class="col-12"
                variant="outline-primary"
                @click="$bvModal.hide('modal-1')"
              >
                Отмена
              </b-button></b-col
            >
            <b-col
              ><b-button
                class="col-12"
                variant="primary"
                :disabled="!valid"
                @click="saveChanges()"
              >
                Сохранить
              </b-button></b-col
            >
          </b-form-row>
        </b-form>
      </ValidationObserver>
    </b-modal>
  </b-col>
</template>

<script>
import {
  BRow,
  BCol,
  BAvatar,
  BButton,
  BLink,
  BCard,
  BInputGroup,
  BFormInput,
  BFormGroup,
  BForm,
  BFormRow,
  BModal,
} from "bootstrap-vue";

import axios from "axios";

export default {
  data() {
    return {
      orgname: "",
      inn: "",
      kpp: "",
      legal_address: "",
      billing_email: "",
      new_orgname: "",
      new_inn: "",
      new_kpp: "",
      new_legal_address: "",
      new_billing_email: "",
    };
  },
  components: {
    BRow,
    BCol,
    BAvatar,
    BButton,
    BLink,
    BCard,
    BInputGroup,
    BFormInput,
    BForm,
    BFormRow,
    BFormGroup,
    BModal,
  },
  async mounted() {
    await this.getData();
    this.new_orgname = this.orgname;
    this.new_billing_email = this.billing_email;
    this.new_inn = this.inn;
    this.new_kpp = this.kpp;
    this.new_legal_address = this.legal_address;
  },
  methods: {
    async getData() {
      const { data } = await axios.get(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/clients/info`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      this.orgname = data["org_name"];
      this.billing_email = data["billing_email"];
      this.inn = data["inn"];
      this.kpp = data["kpp"];
      this.legal_address = data["legal_address"];
    },
    saveChanges() {
      this.orgname = this.new_orgname;
      this.billing_email = this.new_billing_email;
      this.inn = this.new_inn;
      this.kpp = this.new_kpp;
      this.legal_address = this.new_legal_address;
      axios
        .post(
          `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/profile/update`,
          {
            org_name: this.new_orgname,
            billing_email: this.new_billing_email,
            inn: this.new_inn,
            kpp: this.new_kpp,
            legal_address: this.new_legal_address,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.$bvModal.hide("modal-1");
    },
  },
};
</script>
